// extracted by css-extract-rspack-plugin
export default {"wrapper":"Alert-module__wrapper___F7iIm","root":"Alert-module__root___uD0jK"};